import * as React from "react";
import { SVGProps } from "react";

const Origintrail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 24 24"
    {...props}
  >
    <g transform="translate(4.087 3.1)">
      <linearGradient
        id="a"
        x1={-793.078}
        x2={-793.385}
        y1={410.044}
        y2={409.671}
        gradientTransform="matrix(5.925 0 0 -4.867 4715.603 2009.563)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path
        fill="url(#a)"
        fillRule="evenodd"
        d="m13 13.3 4.7 4v-.1c.4-.5.8-1.1 1.2-1.7l-5.3-3.1-.6.9z"
        clipRule="evenodd"
      />
      <linearGradient
        id="b"
        x1={-807.454}
        x2={-807.631}
        y1={395.106}
        y2={394.771}
        gradientTransform="matrix(6.51 0 0 -4.232 5274.286 1682.787)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path
        fill="url(#b)"
        fillRule="evenodd"
        d="M14.4 9.3h6.1v.1c0 .6-.1 1.2-.2 1.8v.4c-.1.6-.3 1.2-.5 1.8v.1L14 11.4c.3-.6.4-1.3.4-2.1z"
        clipRule="evenodd"
      />
      <linearGradient
        id="c"
        x1={-824.856}
        x2={-824.512}
        y1={439.147}
        y2={438.574}
        gradientTransform="matrix(7.383 0 0 -6.886 6105.37 3027.752)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path
        fill="url(#c)"
        fillRule="evenodd"
        d="M19 3.1c.3.6.6 1.2.8 1.8l.1.1v.1c.2.6.4 1.2.5 1.8V7l-6 1.1c-.2-1.1-.6-2.1-1.3-2.9l4.7-4v.1L19 3.1z"
        clipRule="evenodd"
      />
      <linearGradient
        id="d"
        x1={-833.283}
        x2={-832.424}
        y1={446.1}
        y2={445.471}
        gradientTransform="matrix(7.881 0 0 -7.625 6575.341 3400.076)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path
        fill="url(#d)"
        fillRule="evenodd"
        d="M9.4 3.2c-.4-.1-.7-.1-1.1-.1v-6.2c.7 0 1.4.1 2.1.2.7.1 1.3.3 2 .5.6.2 1.3.5 1.9.9.6.3 1.1.7 1.7 1.2h.1l-3.9 4.7c-.5-.5-1.2-.8-1.8-1.1-.3 0-.7-.1-1-.1z"
        clipRule="evenodd"
      />
      <path
        fill="#1d2667"
        d="M8.3-3.1v6.2c-3.4 0-6.2 2.8-6.2 6.2s2.8 6.2 6.2 6.2c1.8 0 3.6-.8 4.7-2.2l4.7 4c-2.3 2.8-5.8 4.4-9.4 4.4C1.5 21.7-4 16.2-4 9.3S1.4-3.1 8.3-3.1zm5.8 14.5 5.8 2.1c-.2.7-.6 1.3-.9 2l-5.3-3.1c.1-.3.3-.6.4-1zm6.3-4.3c.1.7.2 1.4.2 2.2h-6.1c0-.4 0-.7-.1-1.1l6-1.1zM16.2-.2c.5.5 1.1 1 1.5 1.5l-4.7 4c-.2-.3-.5-.5-.8-.8l4-4.7z"
      />
    </g>
  </svg>
);

export default Origintrail;
